import { gql } from '@apollo/client';

export const PersonEmailChangeFragment = gql`
  fragment PersonEmailChange on IPersonEmailChange {
    newEmail
    expirationDate
  }
`;
